import {
  IconPropsInterface,
  IconSpriteEnvelopeFilled,
  IconSpritePhoneFilled,
  IconSpriteWhatsappFilled,
} from '@propertyfinder/icons';
import { FunctionComponent, h } from 'preact';

import { PropertyContactedTypeEnum } from 'common/data/property-contacted/type.enum';

export const LastContactedIconTemplate: FunctionComponent<{ type: PropertyContactedTypeEnum; className: string }> = ({
  className,
  type,
}) => {
  let Icon: FunctionComponent<IconPropsInterface> | null = null;

  switch (type) {
    case PropertyContactedTypeEnum.call:
    case PropertyContactedTypeEnum.callBack:
      Icon = IconSpritePhoneFilled;
      break;
    case PropertyContactedTypeEnum.sms:
    case PropertyContactedTypeEnum.email:
      Icon = IconSpriteEnvelopeFilled;
      break;
    case PropertyContactedTypeEnum.whatsApp:
      Icon = IconSpriteWhatsappFilled;
      break;
  }

  return Icon && <Icon className={className} />;
};
